import { createSelector } from '@reduxjs/toolkit';
import { GIS_SEARCH } from './constants';

/**
 * Memoized selector for GIS search queries formatted for search.
 * Only recalculates when the suggested addresses queries actually change.
 */
const selectGisSearch = createSelector(
  [state => state.getSuggestedAddressesApi.queries],
  suggestedAddressesQueries => {
    if (!suggestedAddressesQueries) {
      return {
        keys: ['_query'],
        data: [],
      };
    }

    const suggestedAddresses = Object.keys(suggestedAddressesQueries).map(
      k => ({
        ...(suggestedAddressesQueries[k] || {}),
        _query: k,
        _datasetName: GIS_SEARCH,
      }),
    );

    return {
      keys: ['_query'],
      data: suggestedAddresses,
    };
  },
);

export default selectGisSearch;
